import { create } from "zustand";

export type Session = {
    firstname: string;
    lastname: string;
    email: string;
    company: string;
    street: string;
    number: string;
    postcode: string;
    city: string;
    country: string;
    tel1: number;
    tel2: number;
    verified: string;
};

export type SessionType = {
    session: Session | null;
    initialized: boolean;
    setInitialized: (initialized: boolean) => void;
    setSession: (session: Session) => void;
};

export const useSessionContext = create<SessionType>()((set) => ({
    session: null,
    initialized: false,
    setInitialized: (initialized) => set(() => ({ initialized: initialized })),
    setSession: (session) => set(() => ({ session: session })),
}));
